module.exports = __webpack_public_path__ + "static/media/handmade-grey.04602c37.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/maker/handmade-grey.svg
 ** module id = 467
 ** module chunks = 0
 **/